import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      nav("/");
      return;
    }

    api.post("/auth/google/session", null, { headers: { "X-Session-ID": sessionId } })
      .then((r) => {
        // For cross-domain guarantees, also store session_token as fallback bearer
        if (r.data.session_token) {
          localStorage.setItem("bc_token", r.data.session_token);
        }
        setUser(r.data.user);
        toast.success(`Welcome, ${r.data.user.name.split(" ")[0]}.`);
        window.history.replaceState(null, "", "/");
        nav("/");
      })
      .catch(() => {
        toast.error("Sign-in failed. Please try again.");
        nav("/login");
      });
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F6F0]">
      <p className="font-serif italic text-2xl text-[#1A1714]/60">Opening your shelf…</p>
    </div>
  );
}
